import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import AboutUsPageImage from "../assets/img/AboutUsPageImage.jpg";
import qualityFoodIcon from "../assets/img/qualityFoodIcon.png";
import freshnessIcon from "../assets/img/freshnessIcon.png";
import customeCreationIcon from "../assets/img/customeCreationIcon.png";
import signatureSpecialIcon from "../assets/img/signatureSpecialIcon.png";
import aboutUsPageNewImage from "../assets/img/aboutUsPageNewImage.webp";
import cake_img10 from "../assets/img/cake_img10.png";
import manOne from "../assets/img/manOne.jpg";
import manTwo from "../assets/img/manTwo.jpg";
import Slider from "react-slick";
import { motion } from "framer-motion";

function About() {
  useEffect(() => {
    document.title = "Zeppoli Bakers | About Us";
    window.scrollTo(0, 0); // Scroll to the top of the page
  }, []);

  const directorsSliderSettings = {
    autoplay: true,
    autoplaySpeed: 2000,
    arrows: false,
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1399,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  // for animation begin
  const [screenSize, setScreenSize] = useState(window.innerWidth);
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const handleResize = () => {
      setScreenSize(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 100);

    // Cleanup timeout if the component unmounts
    return () => clearTimeout(timer);
  }, []);
  // upside animation
  const variants5 = {
    hidden: { opacity: 0, y: 100 },
    visible: (i) => ({
      opacity: 1,
      y: 0,
      transition: {
        delay: i * 0.2,
        type: "spring",
        stiffness: 50,
        damping: 20,
      },
    }),
  };
  // downside animation
  const variants6 = {
    hidden: { opacity: 0, y: -100 },
    visible: (i) => ({
      opacity: 1,
      y: 0,
      transition: {
        delay: i * 0.2,
        type: "spring",
        stiffness: 50,
        damping: 20,
      },
    }),
  };
  // right side animation
  const rightSide = {
    hidden: {
      opacity: 0,
      x: screenSize < 401 ? 100 : screenSize < 739 ? 100 : 200,
    },
    visible: (i) => ({
      opacity: 1,
      x: 0,
      transition: {
        delay: i * 0.2,
        type: "spring",
        stiffness: 50,
        damping: 20,
      },
    }),
  };
  // left side animation
  const leftSide = {
    hidden: {
      opacity: 0,
      x: screenSize < 401 ? -100 : screenSize < 739 ? -100 : -200,
    },
    visible: (i) => ({
      opacity: 1,
      x: 0,
      transition: {
        delay: i * 0.2,
        type: "spring",
        stiffness: 50,
        damping: 20,
      },
    }),
  };
  const leftSideTwo = {
    hidden: {
      opacity: 0,
      x: screenSize < 401 ? -100 : screenSize < 739 ? -100 : -200,
    },
    visible: (i) => ({
      opacity: 1,
      x: 0,
      transition: {
        delay: i * 20,
        type: "spring",
        stiffness: 50,
        damping: 20,
      },
    }),
  };
  const leftSideThree = {
    hidden: {
      opacity: 0,
      x: screenSize < 401 ? -100 : screenSize < 739 ? -100 : -200,
    },
    visible: (i) => ({
      opacity: 1,
      x: 0,
      transition: {
        delay: i * 40,
        type: "spring",
        stiffness: 50,
        damping: 20,
      },
    }),
  };
  // for animation end

  return (
    <>
      <Navbar />

      <motion.div
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true }}
        variants={variants5}
      >
        <div className="breadcumb-wrapper " data-bg-src={AboutUsPageImage}>
          <div
            className="container z-index-common"
            style={{ marginTop: "150px" }}
          >
            <div className="breadcumb-content">
              <h1 className="breadcumb-title text-white">About Us</h1>
              <ul className="breadcumb-menu">
                <li>
                  <Link className="text-white" to="/">
                    Home
                  </Link>
                </li>
                <li className="text-white">About Us</li>
              </ul>
            </div>
          </div>
        </div>
      </motion.div>

      {isVisible && (
        <div className="about-sec overflow-hidden space">
          <div className="container">
            <div className="row">
              <div className="col-xl-5">
                <motion.div
                  initial="hidden"
                  whileInView="visible"
                  viewport={{ once: true }}
                  variants={variants6}
                >
                  <div className="img-box6">
                    <div className="img2">
                      <img
                        src={aboutUsPageNewImage}
                        className="border-radius-12px"
                        alt="Zeppoli aboutus image"
                      />
                    </div>
                  </div>
                </motion.div>
              </div>
              <div className="col-xl-7 align-content-center">
                <motion.div
                  initial="hidden"
                  whileInView="visible"
                  viewport={{ once: true }}
                  variants={rightSide}
                >
                  <div className="title-area mb-30 text-center text-xl-start">
                    <h2 className="sec-title">
                      We make sure Quality & Healthy Foods
                    </h2>
                  </div>
                  <p className="mt-n2 mb-25 text-center text-xl-start">
                    'Zeppoli Bakers' is a leading bakery factory based in the
                    scenic town of Dhoraji in the Saurashtra region. We have
                    been providing our customers with the highest quality baked
                    goods for many years. Our bakery is known for its delicious
                    cakes, pastries, bread, buns, toasts, and other bakery
                    products. We take great pride in using only the freshest and
                    finest ingredients in all of our products to ensure that our
                    customers enjoy the best possible taste.
                  </p>
                </motion.div>
              </div>
            </div>
          </div>
          <div
            className="shape-mockup moving d-none d-lg-block"
            style={{ right: "0%" }}
          >
            <img src={cake_img10} alt="Zeppoli shape icon" />
          </div>
        </div>
      )}

      {isVisible && (
        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          variants={leftSide}
        >
          <section className="">
            <div className="container mb-gutter-negative">
              <div className="title-area">
                <h1 className="sec-title">Utmost cleanliness and sanitation</h1>
                <p>
                  We maintains the highest possible level of cleanliness and
                  hygiene in all aspects of its operations, from the ingredients
                  used to the preparation and storage areas. This is essential
                  to ensure the safety and quality of the baked goods produced,
                  as well as to promote a healthy and hygienic environment for
                  both customers and employees.
                </p>
              </div>
            </div>
          </section>
        </motion.div>
      )}

      {isVisible && (
        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          variants={leftSideTwo}
        >
          <section className="">
            <div className="container mb-gutter-negative">
              <div className="title-area">
                <h1 className="sec-title">Our Vision</h1>
                <p>
                  Our vision at Zeppoli Bakers is to become a leading bakery
                  brand not only in Gujarat but also around the world. We
                  envision expanding our business and exporting our products to
                  dierent parts of the globe while maintaining our high
                  standards of quality and hygiene. We aim to achieve this by
                  continuously innovating our products and services, expanding
                  our reach through franchisees, and building long-term
                  relationships with our customers.
                </p>
              </div>
            </div>
          </section>
        </motion.div>
      )}

      {isVisible && (
        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          variants={leftSideThree}
        >
          <section className="">
            <div className="container mb-gutter-negative">
              <div className="title-area">
                <h1 className="sec-title">Core Values</h1>
                <div>1. Sharing Happiness</div>
                <div>2. Customer Satisfaction</div>
                <div>3. Team Work</div>
                <div>4. Be a Solution Provider</div>
                <div>5. Continuously Improvement</div>
              </div>
            </div>
          </section>
        </motion.div>
      )}

      {isVisible && (
        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          variants={leftSideTwo}
        >
          <section className="">
            <div className="container mb-gutter-negative">
              <div className="title-area">
                <h1 className="sec-title">Core Purpose</h1>
                <p>To make people's celebration more joyful.</p>
              </div>
            </div>
          </section>
        </motion.div>
      )}

      <section className="space-bottom">
        <div className="container">
          <div className="row gy-4 justify-content-center">
            {isVisible && (
              <div className="col-xl-3 col-sm-6">
                <motion.div
                  initial="hidden"
                  whileInView="visible"
                  viewport={{ once: true }}
                  variants={variants6}
                >
                  <div className="why-feature">
                    <div className="why-feature_icon">
                      <img src={qualityFoodIcon} alt="Zeppoli icon for qaulity food" width={"60px"} />
                    </div>
                    <h3 className="why-feature_title">Quality Foods</h3>
                    <p className="why-feature_text">
                      Discover the difference of premier ingredients in our
                      Quality Foods, carefully selected to elevate the flavor
                      profile of each delectable creation.
                    </p>
                  </div>
                </motion.div>
              </div>
            )}
            {isVisible && (
              <div className="col-xl-3 col-sm-6">
                <motion.div
                  initial="hidden"
                  whileInView="visible"
                  viewport={{ once: true }}
                  variants={variants5}
                >
                  <div className="why-feature">
                    <div className="why-feature_icon">
                      <img src={freshnessIcon} alt="Zeppoli icon for daily freshness" width={"60px"} />
                    </div>
                    <h3 className="why-feature_title">Daily Freshness</h3>
                    <p className="why-feature_text">
                      Experience the joy of daily freshness as our bakery items
                      are prepared with the finest ingredients to delight your
                      taste buds.
                    </p>
                  </div>
                </motion.div>
              </div>
            )}
            {isVisible && (
              <div className="col-xl-3 col-sm-6">
                <motion.div
                  initial="hidden"
                  whileInView="visible"
                  viewport={{ once: true }}
                  variants={variants6}
                >
                  <div className="why-feature">
                    <div className="why-feature_icon">
                      <img
                        src={customeCreationIcon}
                        alt="Zeppoli icon for custom creation"
                        width={"60px"}
                      />
                    </div>
                    <h3 className="why-feature_title">Custom Creations</h3>
                    <p className="why-feature_text">
                      Personalize your sweet moments with our custom creations,
                      crafted to perfection and tailored to your unique
                      preferences.
                    </p>
                  </div>
                </motion.div>
              </div>
            )}
            {isVisible && (
              <div className="col-xl-3 col-sm-6">
                <motion.div
                  initial="hidden"
                  whileInView="visible"
                  viewport={{ once: true }}
                  variants={variants5}
                >
                  <div className="why-feature">
                    <div className="why-feature_icon">
                      <img
                        src={signatureSpecialIcon}
                        alt="Zeppoli icon for signature special"
                        width={"60px"}
                      />
                    </div>
                    <h3 className="why-feature_title">Signature Specials</h3>
                    <p className="why-feature_text">
                      Dive into a world of culinary excellence with our
                      signature specials, a collection of uniquely crafted
                      bakery items that define our expertise.
                    </p>
                  </div>
                </motion.div>
              </div>
            )}
          </div>
        </div>
      </section>

      <section className="space-bottom">
        <div className="container">
          {isVisible && (
            <motion.div
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true }}
              variants={variants5}
            >
              <div className="title-area text-center">
                <h2 className="sec-title">Meet our Directors</h2>
              </div>
            </motion.div>
          )}
          {isVisible && (
            <motion.div
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true }}
              variants={variants5}
            >
              <Slider
                {...directorsSliderSettings}
                className="row th-carousel"
                data-slide-show="4"
                data-arrows="true"
              >
                <div className="col-md-6 col-lg-4 col-xl-3 px-2">
                  <div className="th-team team-box">
                    <div className="team-img">
                      <img src={manOne} alt="Zeppoli managing director image" />
                    </div>
                    <div className="team-content-wrap">
                      <span className="team-desig">Managing Director</span>
                      <div className="team-content">
                        <h3 className="team-title">
                          Mr. Jayeshbhai Mavani
                        </h3>
                        <p>
                          We envision a world in which Zeppoli's cake is served
                          at the beginning of every celebration.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-6 col-lg-4 col-xl-3 px-2">
                  <div className="th-team team-box">
                    <div className="team-img">
                      <img src={manTwo} alt="Zeppoli managing director image" />
                    </div>
                    <div className="team-content-wrap">
                      <span className="team-desig">Managing Director</span>
                      <div className="team-content">
                        <h3 className="team-title">
                          Mr. Hiteshbhai Khichadiya
                        </h3>
                        <p>
                          We envision a world in which our customers and clients
                          get world-class hospitality in every city across the
                          world.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-6 col-lg-4 col-xl-3 px-2">
                  <div className="th-team team-box">
                    <div className="team-img">
                      <img src={manOne} alt="Zeppoli managing director image" />
                    </div>
                    <div className="team-content-wrap">
                      <span className="team-desig">Managing Director</span>
                      <div className="team-content">
                        <h3 className="team-title">Mr. Pankajbhai Siroya</h3>
                        <p>
                          We share enjoyment with our cherished customers in
                          addition to selling goods.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-6 col-lg-4 col-xl-3 px-2">
                  <div className="th-team team-box">
                    <div className="team-img">
                      <img src={manTwo} alt="Zeppoli managing director image" />
                    </div>
                    <div className="team-content-wrap">
                      <span className="team-desig">Managing Director</span>
                      <div className="team-content">
                        <h3 className="team-title">Mr. Tusharbhai Hirapara</h3>
                        <p>Every firm relies on its products and services.</p>
                      </div>
                    </div>
                  </div>
                </div>
              </Slider>
            </motion.div>
          )}
        </div>
      </section>

      <Footer />
    </>
  );
}

export default About;
